import { render, staticRenderFns } from "./nonEmbedded.vue?vue&type=template&id=2fdf1425&scoped=true&"
import script from "./nonEmbedded.vue?vue&type=script&lang=js&"
export * from "./nonEmbedded.vue?vue&type=script&lang=js&"
import style0 from "./nonEmbedded.vue?vue&type=style&index=0&id=2fdf1425&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf1425",
  null
  
)

export default component.exports